import React from 'react';
import HeaderSection from '../../common/HeaderSection';
import { ContactHeaderImg } from '../../ImagePaths';

const sectionHeader = {
  image: ContactHeaderImg,
  title: 'Contact Us',
  caption: `
    <p class="fs-display5 mb-5">
      Contact a Simply Retirement by Principal<small><sup>®</sup></small> team member at Ubiquity.
    </p>
  `,
  alt: 'Two women enjoying the outdoors.',
  copy: ``,
};

const newPlanSupport = [
  {
    id: 2,
    category: 'New plan sales',
    description: 'How can I get support to purchase the plan?',
    headline: 'Sales',
    phone: '844-804-0604',
    date: 'Monday-Friday, 6 a.m. - 5 p.m. PT',
  },
  {
    id: 1,
    category: 'New plan onboarding',
    description: 'How can I get support to set up the plan?',
    headline: 'Client onboarding support',
    email: 'newplan@myubiquity.com',
    phone: '855-910-4015',
    date: 'Monday-Friday, 6 a.m. - 5 p.m. PT',
  },
];

const existingPlanSupport = [
  {
    id: 3,
    headline: 'Plan sponsor support',
    email: 'SimplySupport@myubiquity.com',
    phone: '855-700-5569',
    date: 'Monday–Friday, 6 a.m. – 5 p.m. PT',
  },
  {
    id: 2,
    headline: 'Participant support',
    email: 'info@myubiquity.com',
    phone: '855-401-4357',
    date: 'Monday–Friday, 6 a.m. – 5 p.m. PT',
  },
  {
    id: 1,
    headline: 'Financial professional support',
    email: 'SimplySupport@myubiquity.com',
    phone: '855-700-5569',
    date: 'Monday–Friday, 6 a.m. – 5 p.m. PT',
  },
  {
    id: 0,
    headline: 'TPA support',
    email: 'TPAsupport@myubiquity.com',
    phone: '855-700-5569',
    date: 'Monday–Friday, 6 a.m. – 5 p.m. PT',
  },
];

const Investments = () => (
  <div className="about-page mb-5 pb-5">
    <HeaderSection
      image={sectionHeader.image}
      title={sectionHeader.title}
      caption={sectionHeader.caption}
      copy={sectionHeader.copy}
      alt={sectionHeader.alt}
    />

    <section
      className="section section_pb-5"
      style={{ marginTop: '-120px', zIndex: '1' }}
    >
      <div className="container-xl px-0">
        <section
          className="pb-5 bg-white lg:pt-120px pt-50px"
          style={{ borderTopRightRadius: '50px', borderTopLeftRadius: '50px' }}
        >
          <div className="container">
            <div className="row mb-5">
              <div className="col-lg-10 mx-auto">
                <div className="row row-cols-md-2 row-cols-1 mb-5">
                  {newPlanSupport.map((category) => (
                    <div
                      className="col d-flex align-items-stretch"
                      key={category.id}
                    >
                      <div className="w-100 d-flex flex-column">
                        <div className="mb-4">
                          <h5 className="fs-h3 fw-bold text-principal-purple mt-4">
                            {category.category}
                          </h5>
                          <p className="fs-h2">{category.description}</p>
                        </div>
                        <div
                          className="plan-resource-card flex-grow-1 d-flex flex-column justify-content-between"
                          style={{ height: '100%' }}
                        >
                          <div>
                            <div className="fs-h6">
                              <strong>{category.headline}</strong>
                            </div>
                            {category.email && (
                              <div className="fs-disclaimer mb-2">
                                <a href={`mailto:${category.email}`}>
                                  {category.email}
                                </a>
                              </div>
                            )}
                            <div className="fs-disclaimer mb-2 text-decoration-underline">
                              <a
                                href={`tel:${category.phone.replace(/-/g, '')}`}
                              >
                                {category.phone}
                              </a>
                            </div>
                            <div className="fs-disclaimer mb-2">
                              {category.date}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Existing Plan Support Section */}
                <div className="mb-4">
                  <h5 className="fs-h3 fw-bold text-principal-purple mt-4">
                    Existing plan support
                  </h5>
                  <p className="fs-h2">
                    How do I get support after my plan is set up?
                  </p>
                </div>
                <div className="row row-cols-md-2 row-cols-1 mb-5">
                  {existingPlanSupport.map((card) => (
                    <div className="col" key={card.id}>
                      <div className="plan-resource-card">
                        <div className="fs-h6">
                          <strong>{card.headline}</strong>
                        </div>
                        <div className="fs-disclaimer mb-2">
                          <a href={`mailto:${card.email}`}>{card.email}</a>
                        </div>
                        <div className="fs-disclaimer mb-2 text-decoration-underline">
                          <a href={`tel:${card.phone.replace(/-/g, '')}`}>
                            {card.phone}
                          </a>
                        </div>
                        <div className="fs-disclaimer mb-2">{card.date}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
);

export default Investments;
